module.exports = __webpack_public_path__ + "static/media/RecomendaNatal.d6fda170.jpg";